import { render, staticRenderFns } from "./TextInputWrapper.vue?vue&type=template&id=3a0c87de&scoped=true"
import script from "./TextInputWrapper.vue?vue&type=script&lang=ts"
export * from "./TextInputWrapper.vue?vue&type=script&lang=ts"
import style0 from "./TextInputWrapper.vue?vue&type=style&index=0&id=3a0c87de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0c87de",
  null
  
)

export default component.exports